(function () {
  'use strict';

  var overlay = document.querySelector('[data-yc-menu-overlay]');
  var openBtn = document.querySelector('[data-yc-menu-open]');
  var closeEls = document.querySelectorAll('[data-yc-menu-close]');
  if (!overlay || !openBtn) return;

  var lastFocus = null;

  function openMenu() {
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var firstLink = overlay.querySelector('a, button');
    if (firstLink) firstLink.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeMenu() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus) lastFocus.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') closeMenu();
  }

  openBtn.addEventListener('click', openMenu);
  closeEls.forEach(function (el) { el.addEventListener('click', closeMenu); });

  // click on dim backdrop (overlay itself, not the panel) closes
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeMenu();
  });

  // close when a menu link is tapped
  overlay.querySelectorAll('.yc-menu-overlay__links a').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });

  // ---- keep floating cart badge in sync with AJAX cart ----
  function updateCartCount(count) {
    document.querySelectorAll('[data-yc-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
    });
  }

  // Dawn publishes cart updates via PubSub; also poll /cart.js after add events.
  function refreshCart() {
    fetch(window.routes ? window.routes.cart_url + '.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); })
      .catch(function () {});
  }

  // Subscribe to Dawn's cart-update pub/sub. `subscribe` and `PUB_SUB_EVENTS`
  // are global bare identifiers from pubsub.js / constants.js (const does not
  // attach to window), so reference them directly with typeof guards.
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.item_count !== 'undefined') {
          updateCartCount(event.cartData.item_count);
        } else {
          refreshCart();
        }
      });
    }
  } catch (e) {
    /* pubsub not available — form-submit fallback below still works */
  }

  // Fallback: refresh on any add-to-cart form submit
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      setTimeout(refreshCart, 600);
    }
  });
})();
